export default __webpack_public_path__ + "static/media/screenshot.ddbba144.webp";